import { createBrowserRouter, RouterProvider } from "react-router-dom";
import RootLayout from "./Components/UI/Root";
import Home from "./Components/Pages/Home/Home";
import FrontPage from "./Components/Pages/Front Pages/FrontPage";
import InnerPage from "./Components/Pages/Inner Page/InnerPage";
import LavabiFrontPage from "./Components/Pages/Lavabi Front Page/FrontPage";
import PianiFrontPage from "./Components/Pages/Piani Front Page/FrontPage";
import SpecchiFrontPage from "./Components/Pages/Specchi Front Page/FrontPage";
import LampadeFrontPage from "./Components/Pages/Lampade Front Page/FrontPage";
import MiscelatoriFrontPage from "./Components/Pages/Miscelatori Front Page/FrontPage";
import DocciaFrontPage from "./Components/Pages/Doccia Front Page/FrontPage";
import SedieInner from "./Components/Pages/Sedie Inner/Sedienner";
import Cataloghi from "./Components/Pages/Cataloghi/Cataloghi";
import Cataloghi11 from "./Components/Pages/Cataloghi11/Cataloghi11";
import Rivenditori from "./Components/Rivenditori/Rivenditori";
import Contacts from "./Components/Pages/Contatti/Contacts";
import News from "./Components/Pages/News/News";
import NewsInner from "./Components/Pages/News/NewsInner";
import Azienda from "./Components/Pages/Azienda/azienda";
import Cookies from "./Components/Pages/Cookies/cookies";
import Policy from "./Components/Pages/Policy/policy";
import Certificazioni from "./Components/Pages/Certificazioni/Certificazioni";

import NotFoundComponent from "./Components/NotFound";

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <RootLayout />,
      // errorElement: <ErrorPage />,
      id: "root",
      children: [
        {
          index: true,
          element: <Home />,
        },
        {
          element: <FrontPage link={"bagnis"} />,
          path: "bagni/:slug",
        },

        {
          element: <FrontPage link={"lavanderias"} />,
          path: "lavanderia/:slug",
        },
        {
          element: <LavabiFrontPage link={"lavabis"} />,
          path: "lavabi/:slug",
        },
        {
          element: <PianiFrontPage link={"pianis"} />,
          path: "piani/:slug",
        },
        {
          element: <SpecchiFrontPage link={"specchis"} />,
          path: "specchi/:slug",
        },
        {
          element: <LampadeFrontPage link={"lampades"} />,
          path: "lampade/:slug",
        },
        {
          element: <MiscelatoriFrontPage link={"miscelatoris"} />,
          path: "miscelatori/:slug",
        },
        {
          element: <DocciaFrontPage link={"doccias"} />,
          path: "doccia/:slug",
        },
        {
          element: <InnerPage />,
          path: ":main_page/:product_name/:locale",
        },
        {
          element: <SedieInner />,
          path: "lavabi/:slug/:product_name",
        },
        {
          element: <SedieInner />,
          path: "piani/:slug/:product_name",
        },
        {
          element: <SedieInner />,
          path: "specchi/:slug/:product_name",
        },
        {
          element: <SedieInner />,
          path: "lampade/:slug/:product_name",
        },
        {
          element: <SedieInner />,
          path: "miscelatori/:slug/:product_name",
        },
        {
          element: <SedieInner />,
          path: "doccia/:slug/:product_name",
        },
        {
          element: <Cataloghi />,
          path: "/cataloghi",
        },
        {
          element: <Cataloghi11 />,
          path: "/scheda-prodotti",
        },
        {
          element: <Rivenditori />,
          path: "/rivenditori",
        },
        {
          element: <Contacts />,
          path: "/contatti",
        },
        {
          element: <News />,
          path: "/news",
        },
        {
          element: <NewsInner />,
          path: "/news/:slug",
        },
        {
          element: <Azienda />,
          path: "/azienda",
        },
        {
          element: <Cookies />,
          path: "/cookies",
        },
        {
          element: <Policy />,
          path: "/policy",
        },
        {
          element: <Certificazioni />,
          path: "/certificazioni",
        },
        {
          path: "*",
          element: <NotFoundComponent />, // Renders the NotFoundComponent on 404
        },
      ],
    },
  ]);
  return <RouterProvider router={router} />;
}

export default App;
